(function () {
  'use strict';
  angular.module('imnApp').factory('AlarmShowService', AlarmShowService);

  AlarmShowService.$inject = ['$http', 'RequestService'];

  function AlarmShowService($http, RequestService) {
    return {
      getAlarmShow: getAlarmShow
    };

    function getAlarmShow(olt) {
      return $http.get(alarmShowApi(olt.id)).then(responseData);
    }

    function responseData(response) {
      return response.data;
    }

    function alarmShowApi(method) {
      return RequestService.apiUrl('alarmshow', method);
    }
  }
})();
